import { useState } from "react";
import { X, ChevronLeft, ChevronRight, RotateCw } from "lucide-react";

// Full-screen flip-through viewer for flashcards items.
export default function FlashcardViewer({ item, onClose }) {
  const cards = item.cards || [];
  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const card = cards[index];

  const go = (dir) => {
    setFlipped(false);
    setIndex((i) => Math.max(0, Math.min(cards.length - 1, i + dir)));
  };

  if (!card) return null;
  return (
    <div data-testid="flashcard-viewer" className="fixed inset-0 z-[70] bg-black/60 flex items-center justify-center px-4" onClick={onClose}>
      <div className="nb-card-static p-7 w-full max-w-xl animate-pop" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="font-display text-xl font-bold">{item.title}</h3>
            <p className="text-xs text-[var(--muted-text)] mt-0.5">Card {index + 1} of {cards.length} — click the card to flip</p>
          </div>
          <button data-testid="flashcard-close" onClick={onClose} className="w-9 h-9 border-2 border-[var(--gold)] rounded-lg flex items-center justify-center hover:bg-[var(--yellow)]">
            <X className="w-4 h-4" />
          </button>
        </div>

        <button
          data-testid="flashcard-card"
          onClick={() => setFlipped((f) => !f)}
          className="w-full min-h-[220px] rounded-xl border-2 border-[var(--gold)] bg-[var(--blue)] p-8 flex flex-col items-center justify-center text-center gap-3 hover:shadow-[0_8px_30px_rgba(212,175,55,0.2)] transition-shadow"
        >
          <span className="text-[10px] tracking-[0.25em] uppercase text-[var(--gold)] font-bold flex items-center gap-1.5">
            <RotateCw className="w-3 h-3" /> {flipped ? "Definition" : "Term"}
          </span>
          <span data-testid="flashcard-text" className={`font-display font-bold leading-snug ${flipped ? "text-lg" : "text-2xl"}`}>
            {flipped ? card.definition : card.term}
          </span>
        </button>

        <div className="mt-5 flex items-center justify-between">
          <button data-testid="flashcard-prev" onClick={() => go(-1)} disabled={index === 0} className="nb-btn nb-btn-white text-sm flex items-center gap-1.5 disabled:opacity-40">
            <ChevronLeft className="w-4 h-4" /> Previous
          </button>
          <div className="flex gap-1">
            {cards.map((_, i) => (
              <span key={i} className={`w-2 h-2 rounded-full ${i === index ? "bg-[var(--gold)]" : "bg-[var(--gold)]/30"}`} />
            ))}
          </div>
          <button data-testid="flashcard-next" onClick={() => go(1)} disabled={index === cards.length - 1} className="nb-btn nb-btn-yellow text-sm flex items-center gap-1.5 disabled:opacity-40">
            Next <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
